module.exports = __webpack_public_path__ + "img/ch10_01_游戏城抓娃娃.656f5090.jpg";